import React, {useEffect, useState} from "react";
import "./../../utils/Style/pages/Banktransfers.scss";
import useCommonAPI from "../../api/CommonAPI";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useDispatch} from "react-redux";
import {useOutletContext} from "react-router-dom";
import BlurLoading from "../../components/BlurLoading";
import {parseFormattedNumber} from "../../features/ValueFormater";
import DropdownInput from "../../components/BankTransfers/DropDownInput";
import NumberInput from "../../components/BankTransfers/NumberInput";


function NewTransferTemplate() {
    const [selectedFile, setSelectedFile] = useState();
    const [payload, setPayload] = useState({
        CurrencyID: "",
        BeneficiaryName: "",
        IBAN: "",
        Amount: "",
        ReasonOfTransfer: "",
        ReasonFileName: "",
        ReasonFile: null,
    });
    // const [amountString, setAmountString] = useState();

    const [errors, setErrors] = useState({});

    const {getAllCurrencies, currencies} = useCommonAPI();

    const [onOpenQrAfterGenerate] = useOutletContext();
    const dispatch = useDispatch();

    useEffect(() => {
        getAllCurrencies();
    }, []);

    useEffect(() => {
        if (selectedFile) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onloadend = () => {
                const base64String = reader.result;
                setPayload((prevState) => ({
                    ...prevState,
                    ReasonFileName: selectedFile.name,
                    ReasonFile: base64String
                }));
            };

        }
    }, [selectedFile]);

    // useEffect(() => {
    //     if (payload.CurrencyID === 2)
    //         setAmountString(formatLBP(payload.Amount));
    //     else
    //         setAmountString(formatUSD(payload.Amount));
    // }, [payload.Amount]);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setPayload({...payload, [name]: value});
        setErrors({...errors, [name]: ""});
    };

    const handleChangeAmount = (event) => {
        setPayload({...payload, Amount: parseFormattedNumber(event.target.value)});
    }


    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!payload.CurrencyID || payload.CurrencyID==="0") {
            newErrors.CurrencyID = "Account is required.";
            isValid = false;
        }

        if (!payload.BeneficiaryName || payload.BeneficiaryName==="Select") {
            newErrors.BeneficiaryName = "Beneficiary Name is required.";
            isValid = false;
        }

        if (!payload.IBAN) {
            newErrors.IBAN = "IBAN Number is required.";
            isValid = false;
        }

        if (!payload.Amount) {
            newErrors.Amount = "Amount is required.";
            isValid = false;
        } else if (isNaN(payload.Amount)) {
            newErrors.Amount = "Amount must be a number.";
            isValid = false;
        } else if (payload.Amount <= 0) {
            newErrors.Amount = "Amount must be a positive number.";
            isValid = false;
        }

        if (!payload.ReasonOfTransfer) {
            newErrors.ReasonOfTransfer = "Reason of transfer is required.";
            isValid = false;
        }

        const fileSizeLimit = 2 * 1024 * 1024; // 2 MB
        if (selectedFile && selectedFile.size > fileSizeLimit){
            newErrors.ReasonFile = "File should not be larger than 2MB.";
            isValid = false;
        }

        //remove comment if file is required
        // if (selectedFile === undefined || selectedFile.name === undefined || selectedFile.size <= 0) {
        //     newErrors.ReasonFile = "File upload is required.";
        //     isValid = false;
        // }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (validateForm()) {
            dispatch(setActionType(ACTION_TYPES.PUSH_BANK_TRANSFER));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        }
    };

    return (
        <>
            <div className="NewTransferTemplate">
                {<BlurLoading/>}

                <div className="title">Transfer money from IBAN to IBAN</div>
                <form className="NewTransferTemplate" onSubmit={handleSubmit} autoComplete="off">
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">From Account</div>
                        <div className="col-lg-6 col-md-7">
                            <select
                                className={!payload.CurrencyID || payload.CurrencyID==="0"? "placeholder-color ddselect": "ddselect"}
                                name="CurrencyID"
                                id="account"
                                value={payload.CurrencyID}
                                onChange={handleChange}
                            >
                                <option value="0">Select one value Only</option>
                                {currencies && currencies.map(({label, value}) => (
                                    <option key={value} value={value}>{label}</option>
                                ))
                                }
                            </select>
                            {errors.CurrencyID && (
                                <span className="error">{errors.CurrencyID}</span>
                            )}
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Amount</div>
                        <div className="col-lg-6 col-md-7">
                            <NumberInput payload={payload} setPayload={setPayload} currency={payload.CurrencyID} objKey="Amount"/>
                            {errors.Amount && <span className="error">{errors.Amount}</span>}
                        </div>
                    </div>
                    <div className="title">Beneficiary Information</div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Beneficiary Name</div>
                        <div className="col-lg-6 col-md-7">
                            <DropdownInput setPayload={setPayload}/>
                            {errors.BeneficiaryName && (
                                <span className="error">{errors.BeneficiaryName}</span>
                            )}
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">IBAN Number</div>
                        <div className="col-lg-6 col-md-7">
                            <input
                                type="text"
                                name="IBAN"
                                placeholder="IBAN Number"
                                value={payload.IBAN}
                                onChange={handleChange}
                            />
                            {errors.IBAN && <span className="error">{errors.IBAN}</span>}
                        </div>
                    </div>

                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Reason for transfer</div>
                        <div className="col-lg-6 col-md-7">
                            <input
                                type="text"
                                placeholder="Describe why you are transferring money"
                                name="ReasonOfTransfer"
                                value={payload.ReasonOfTransfer}
                                onChange={handleChange}
                            />
                            {errors.ReasonOfTransfer && (
                                <span className="error">{errors.ReasonOfTransfer}</span>
                            )}
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Upload File</div>
                        <div className="col-lg-6 col-md-7">
                            <input type="file" id="myFile" name="ReasonFile" onChange={
                                (e) => {
                                    setSelectedFile(e.target.files[0])
                                }
                            }/>
                            {errors.ReasonFile && (
                                <span className="error">{errors.ReasonFile}</span>
                            )}
                        </div>
                    </div>
                    <div className="row submitForm">
                        <div className="btn_place">
                            <button type="submit" className="submitBtn">Confirm</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default NewTransferTemplate;


